var map = {
	"./arrow-left-white.svg": "./src/img/arrow-left-white.svg",
	"./arrow-left.svg": "./src/img/arrow-left.svg",
	"./arrow-right-white.svg": "./src/img/arrow-right-white.svg",
	"./arrow-right.svg": "./src/img/arrow-right.svg",
	"./bg-cta.svg": "./src/img/bg-cta.svg",
	"./bg-hero-default.svg": "./src/img/bg-hero-default.svg",
	"./bg-inner-page-2.png": "./src/img/bg-inner-page-2.png",
	"./bg-inner-page.svg": "./src/img/bg-inner-page.svg",
	"./bg-modal-blocks.png": "./src/img/bg-modal-blocks.png",
	"./bg-modal.svg": "./src/img/bg-modal.svg",
	"./bg-page-middle.png": "./src/img/bg-page-middle.png",
	"./bg-swoosh-middle.svg": "./src/img/bg-swoosh-middle.svg",
	"./bg-tabber-1.svg": "./src/img/bg-tabber-1.svg",
	"./bg-tabber-2.svg": "./src/img/bg-tabber-2.svg",
	"./bg-testimonial-1.png": "./src/img/bg-testimonial-1.png",
	"./bg-testimonial-1.svg": "./src/img/bg-testimonial-1.svg",
	"./bg-wave.svg": "./src/img/bg-wave.svg",
	"./cross.svg": "./src/img/cross.svg",
	"./icon-chevron-down.svg": "./src/img/icon-chevron-down.svg",
	"./icon-chevron-right.svg": "./src/img/icon-chevron-right.svg",
	"./loading.svg": "./src/img/loading.svg",
	"./logo-powered-by.svg": "./src/img/logo-powered-by.svg",
	"./logo.svg": "./src/img/logo.svg",
	"./logo_1.svg": "./src/img/logo_1.svg",
	"./overlay-icon-play.svg": "./src/img/overlay-icon-play.svg",
	"./testimonial-quote.svg": "./src/img/testimonial-quote.svg",
	"./timeline-current-line.svg": "./src/img/timeline-current-line.svg",
	"./timeline-pointer.svg": "./src/img/timeline-pointer.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img sync recursive \\.(jpg|jpeg|gif|png|svg|webp)$";